import React from 'react';
import createRoutes from './routes';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { ThemeProvider } from '@material-ui/core/styles';
import defaultTheme from './themes/DefaultTheme/DefaultTheme';
import AppContainer from './AppContainer';
import { history } from './helpers/history';
// import GlobalModal from 'components/Modal/GlobalModal';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;

const App = () => {
  const { store, persistor } = configureStore();

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Provider store={store}>
        <ThemeProvider theme={defaultTheme}>
          <PersistGate loading={null} persistor={persistor}>
            <AppContainer history={history}>{createRoutes()}</AppContainer>
            {/* <GlobalModal /> */}
          </PersistGate>
        </ThemeProvider>
      </Provider>
    </GoogleOAuthProvider>
  );
};

export default App;
